import React, { useEffect, useState } from 'react';
import './styles.scss';
import { apiService } from 'utils/api';
import BrandReviewCard from 'components/kitchen/brand-review-card';
import { getKitchenTeam } from 'utils/functions';
import { SocketIOConnection } from 'utils/socket_client';
const KitchenStatsPageSeven = () => {
  const activeTeam = getKitchenTeam();
  const [data, setData] = useState([] as any);

  const connectSocket = async () => {
    const conn = await SocketIOConnection.getConnection();
    conn.onReconnect(async () => {
      conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
      await fetchData();
    });

    const roomName = `kitchen-review-stat:${activeTeam}`;
    conn.addEventListener(roomName, 'update', (data: any) => {
      setData(data.data);
    });
    conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
  };

  const fetchData = async () => {
    const res = await apiService.post('kitchen/reviews', {
      baseUrl: 'https://order-api.getfoodcourt.com/v1/',
      data: {
        team: activeTeam
      }
    });
    setData(res.data.data);
    return res.data.data;
  };

  useEffect(() => {
    fetchData();
    connectSocket();
  }, []);
  return (
    <div>
      <p className='intro_heading flex justify-center'>{`Heres what our customers are saying...`}</p>
      {data.length === 0 ? (
        <div className='text-xl text-center mt-10'>No data</div>
      ) : (
        <div className='grid grid-cols-3'>
          {data?.map((item: any, index: number) => (
            <BrandReviewCard key={index} data={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default KitchenStatsPageSeven;
